import { createFileRoute } from '@tanstack/react-router';
import { DemandPage } from '@/page/admin/DemandPage';

export const Route = createFileRoute('/_app/admin/demand')({ component: DemandPage });
